/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useState } from 'react';
import { Redirect, Route, useLocation, useHistory } from 'react-router';
import { Empty, Spin } from 'antd';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import LeftLayout from '~/layouts/LeftLayout';
import WizardContent from '~/layouts/WizardContent';
import WizardContinueButton from '~/layouts/WizardContinueButton';
import paths from '~/pages/paths';
import features from '~/constants/features';
import { CardHolderContext, CardHolderContextProvider, useCardHolderContext } from '~/controllers/cardHolderContext';
import WizardLayout from '~/layouts/WizardLayout';
import AlertWithContiniueButton from '~/layouts/AlertWithContiniueButton';
import cardHolderDetails from './details';
import cardHolderConsent from './consent';

const views: Record<string, React.ComponentType> = {
  details: cardHolderDetails,
  consent: cardHolderConsent,
};

type RouteConfig = {
  path: string;
  exact: boolean;
  component: any;
};

interface Props {
  routes: RouteConfig[];
}

const CardHolder: FC<Props> = (props) => {
  const { routes } = props;
  const location = useLocation();

  return (
    <CardHolderContextProvider>
      <WizardLayout>
        <WizardContent
          left={
            <LeftLayout>
              <BottomLeftActions contactUsUrl={features.contactUsLinkWizardApplication} />
            </LeftLayout>
          }
          content={
            <>
              {routes.map((route) => {
                const { path, exact, component } = route;
                return <Route path={path} key={path} exact={exact} component={component} />;
              })}
            </>
          }
          right={
            location.pathname === '/cardHolder/consent' ? (
              <>
                <WizardContinueButton id="cardHolder_continueButton" formName={location.pathname}>
                  <p>Submit</p>
                </WizardContinueButton>
              </>
            ) : location.pathname !== '/cardHolder/completion' ? (
              <>
                <AlertWithContiniueButton formName={location.pathname} />
              </>
            ) : (
              <></>
            )
          }
        />
      </WizardLayout>
    </CardHolderContextProvider>
  );
};

export default CardHolder;
